// Generated by Node, do not modify this file
export const buildTimestamp = {
  isoTimestamp: '2025-07-03T19:00:27.940Z',
  short: 'Thu, Jul 3, 3:00 PM',
  full: 'Thursday, July 3 at 3:00:27 PM EDT',
};
